module.exports = ".current-one {\n  background-color: #f8fafb !important; }\n\n#timereporting .location-req-btn .switch {\n  width: 40px;\n  height: 22px; }\n\n.disabled-tab {\n  pointer-events: none;\n  opacity: 0.6; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/manage-projects/manage-projects.component.scss
// module id = ./src/app/seller/manage-projects/manage-projects.component.scss
// module chunks = main